// extracted by mini-css-extract-plugin
export default {"rankingRow":"RankRow_rankingRow__34ul-","positionColumn":"RankRow_positionColumn__dDj8B","nameColumn":"RankRow_nameColumn__jzxCB","pointsColumn":"RankRow_pointsColumn__Zxh1k"};